export enum ViewType {
  Card = 'card',
  List = 'list',
}

export enum UserActionType {
  VIEW = 'view',
  EDIT = 'edit',
  DELETE = 'delete',
  ADD = 'add',
}

export enum DocumentUpdateType {
  ATTACHMENT = 0,
  IMAGE = 1,
}

export enum HeadlineType {
  STANDARD = 0,
  ENTERPRISE = 1,
}
